import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useFeature from 'hooks/useFeature';

import { selectTenant } from 'state/tenant';

const useStartPageName = () => {
  const { isEnabled } = useFeature();
  const {
    enabledFeatures: { cardChoices, productChoices },
  } = useSelector(selectTenant);

  const startRoute = useMemo(() => {
    const hasCardChoice = cardChoices.length > 0;

    const hasProductChoice = productChoices.length > 0;

    if (isEnabled('cardSelector')) {
      return 'card-selector';
    } else if (hasProductChoice) {
      return 'product-choice';
    } else if (hasCardChoice) {
      return 'card-choice';
    } else {
      return undefined;
    }
  }, [cardChoices.length, productChoices.length, isEnabled]);

  return startRoute;
};

export default useStartPageName;
